module.exports = __webpack_public_path__ + "static/media/detail_0015_f.77ad01b6.jpg";